import { useLocation, useNavigate } from "react-router-dom";
import CustomBreadcrumb from "../../../components/CustomBreadcrumb";
import { CustomButton } from "../../../components/CustomButton";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import TableActionsContainer from "../../../components/CustomTable/TableActionsContainer";
import { Text } from "../../../components/Text";
import { ZOHO_ACCESS_TYPE, ZOHO_CLIENT_ID, ZOHO_PROMPT, ZOHO_REDIRECT_URI, ZOHO_SCOPE } from "../../../constants/interegation-variebles";
import zohoimg  from "../../../assets/zoho.png";
import { addZohoAuth } from "../../../reducers/marketPlaceSlice";
import { useLayout } from "../../../context/LayoutContext";


function ZOHO() {
  const { user } = useSelector((state) => state.authenticate);
  const { activePlan } = useSelector((state) => state.payment);
  const {toast} =useLayout();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
    useEffect(() => {
      if(window.location.href.includes("auth")){
        const queryParams = new URLSearchParams(location.search);
        if(queryParams.has("code")){
          const code = queryParams.get("code");
          const location = queryParams.get("location");
          const accountsserver = queryParams.get("accounts-server");
          console.log(code);
          dispatch(addZohoAuth({code, location,"accounts-server": accountsserver})).unwrap()
          .then(()=>{
            toast.current.show({ severity: "success", detail: "Zoho Account is Synced." });
          })
          .catch(errResponse=>{
            toast.current.show({ severity: "error", detail: errResponse.message});
          });
        }
      }
    
    }, []);
    const connectzoho=()=>{
    const host = window.location.host;
    const url = `https://accounts.zoho.com/oauth/v2/auth?response_type=code&client_id=${ZOHO_CLIENT_ID}&scope=${ZOHO_SCOPE}&redirect_uri=${ZOHO_REDIRECT_URI}&access_type=${ZOHO_ACCESS_TYPE}&prompt=${ZOHO_PROMPT}`;
    window.location.href = url;
   }

  
  return (
    <div className="w-full bg-white cp-10">
      <CustomBreadcrumb home={{ label: "Market Place", url: "/marketplace" }} itemslist={[{ label: "Zoho", url: "#" }]} />
          
          <div className="mrkt-place-container">
          <div className="mrkt-place-header">
            <div className="mrkt-place-logo-section">
            <img src={zohoimg} alt="Zoho CRM Logo" className="mrkt-place-logo" />
            <h1>Zoho CRM</h1>
            </div>
            <p className="mrkt-place-subtitle">Data Sync - Sync Zoho CRM and SkaleBot data</p>
            <button className="mrkt-place-cta-button" onClick={connectzoho}>Add to SkaleBot</button>
          </div>

          <div className="mrkt-place-video-section w-full lg:w-8 xl:w-6">
            <div className="mrkt-place-video-placeholder ">
              <span className="mrkt-place-play-icon">▶</span>
            </div>
            <h2>Zoho CRM Integration Overview</h2>
            <p>A short video explaining the integration benefits and setup process.</p>
          </div>

          <div className="mrkt-place-benefits-section w-full lg:w-8 xl:w-8">
            <h3>Integration Benefits</h3>
            <ul>
              <li>✅ Two-way sync: Data is shared between Zoho CRM and SkaleBot in real time</li>
              <li>✅ Default field mappings: Set-up is quick with out-of-the-box field mappings already created for you</li>
              <li>✅ Historical syncing: Your existing data will sync right away, and updates will sync as they happen</li>
            </ul>
          </div>
        </div>
    </div>
  );
}

export default ZOHO;
